module.exports = __webpack_public_path__ + "static/img/liveControl-bg2.401dfe20.png";